import { Reveal } from "./Reveal";

export const SectionHead = ({ eyebrow, eyebrowClass = "text-neon", title, right }) => (
  <div className="mb-12 flex flex-col gap-8 md:mb-16 md:flex-row md:items-end md:justify-between">
    <Reveal className="max-w-2xl">
      <p
        className={`mb-4 font-mono text-[11px] font-medium uppercase tracking-[0.25em] ${eyebrowClass}`}
        data-testid="section-eyebrow"
      >
        {eyebrow}
      </p>
      <h2 className="font-display text-3xl font-bold uppercase leading-[1.02] tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {right ? <Reveal delay={0.1}>{right}</Reveal> : null}
  </div>
);
